import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppClientContext } from 'src/app-client/_appCommon/base/AppClientContext';
import { CRUDFormControllerBase } from 'src/app-client/_appCommon/base/CRUDFormControllerBase';
import { UrlQueryDef } from 'src/app-client/_appCommon/base/UrlQueryDef';
import { CaseDataService } from 'src/app-client/_dataservices/CaseDataService';
import { CustomerDataService } from 'src/app-client/_dataservices/CustomerDataService';
import { SystemServicesDataService } from 'src/app-client/_dataservices/security/SystemServicesDataService';
import { ECOMMERCE_USER_TOKEN } from 'src/app/_appCommon/base/Constants';
import { CaseStageDataService } from '../../../app-client/_dataservices/CaseStageDataService';
import { CaseFileDataService } from '../../../app-client/_dataservices/CaseFileDataService';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FileAdditionalArray, FileCompositeArray, FileRadiographyArray, FileSTLArray, FileType, FileTypeArray, FileTypeArrayWOSpace, FileTypeLabel, FileTypeNamePath, StatusesID, UpdateFileDto } from 'src/app-client/_appCommon/base/AppInterfaceAndBaseClasses';
import { BroadcastManager } from 'src/app-client/_appCommon/base/BroadcastManager';
import { AppEventNames } from 'src/app-client/_appCommon/base/Constants';
import { CaseAdditionalFilesDataService } from 'src/app-client/_dataservices/CaseAdditionalFilesDataService';
import { MediaDataService } from 'src/app-client/_dataservices/MediaDataService';
import { PrescriptionDataService } from 'src/app-client/_dataservices/PrescriptionDataService';

@Component({
  selector: 'app-case-files-manager',
  templateUrl: './case-files-manager.component.html',
  styleUrls: ['./case-files-manager.component.css'],
  providers:[
    CaseDataService,
    CaseStageDataService,
    CustomerDataService,
    SystemServicesDataService,
    CaseFileDataService,
    CaseAdditionalFilesDataService,
    MediaDataService
  ]
})
export class CaseFilesManagerComponent  extends CRUDFormControllerBase<CaseDataService> implements OnInit {

  public caseId: number;
  public stageNumber: number;
  public currentCustomer: any;
  public currentStages = [];
  public stageSelected : any;
  public Statuses: any = StatusesID;
  private additionalFilesResponse: any[];
  private caseFileResponse: any[];

  // Array Files
  public fileAdditionalArray: any[];
  public fileCompositeArray: any[];
  public fileImageArray: any[];
  public fileRadiographyArray: any[];
  public fileSTLArray: any[];
  public filePrescription: any;
  

  public prescriptionForm: FormGroup;
  public compositeForm: FormGroup;
  public photographyForm: FormGroup;
  public radiographyForm: FormGroup;
  public stlForm: FormGroup;
  public additionalFilesForm: FormGroup;
  
  constructor(private router: Router,  protected route: ActivatedRoute,  
    protected dataService: CaseDataService,  private customerDataService: CustomerDataService,
    private caseStageDataService: CaseStageDataService,
    private systemServicesDataService: SystemServicesDataService,
    private injector: Injector,
    private caseFileDataService : CaseFileDataService,
    private caseAdditionalDataService: CaseAdditionalFilesDataService,
    private formBuilder: FormBuilder,
    private mediaDataService: MediaDataService,
    private prescriptionDataService: PrescriptionDataService
  ) {
    super(route, dataService);
   }

  ngOnInit(): void {
    this.initializeForms();
    this.initializeArrays();

    this.route.paramMap.subscribe(params =>
      {
        this.caseId = +params.get('id');
        this.stageNumber = +params.get('stageNumber');
      });

    if(AppClientContext.Instance.customerId){
      this.getCustomerInfo(); 
    }
    else{
      this.getStartupInfo();
    }
  }

  private initializeArrays(): void
  {
    this.filePrescription = 
      {
        type: null,
        label: 'Prescripción',
        name: 'prescriptionFile',
        fileInfo: null,
        isRequired: false,
      };

    this.fileCompositeArray = JSON.parse(JSON.stringify(FileCompositeArray));
    this.fileImageArray = JSON.parse(JSON.stringify(FileTypeArrayWOSpace));
    this.fileRadiographyArray = JSON.parse(JSON.stringify(FileRadiographyArray));
    this.fileSTLArray = JSON.parse(JSON.stringify(FileSTLArray));

    //Archivos adicionales
    this.fileAdditionalArray = [JSON.parse(JSON.stringify(FileAdditionalArray))];
    this.fileAdditionalArray[this.fileAdditionalArray.length - 1].name = "AdditionalFile" + (this.fileAdditionalArray.length - 1).toString();
    //Archivos adicionales
  }
  
  private initializeForms(): void
  {
    this.prescriptionForm = this.formBuilder.group(
    {
      prescriptionFile: [null, ''],
    });

    //Archivos adicionaless
    this.additionalFilesForm = this.formBuilder.group(
      {
        AdditionalFile0: [null, ''],
        AdditionalFile1: [null, ''],
        AdditionalFile2: [null, ''],
        AdditionalFile3: [null, ''],
        AdditionalFile4: [null, ''],
        AdditionalFile5: [null, ''],
        AdditionalFile6: [null, ''],
        AdditionalFile7: [null, ''],
        AdditionalFile8: [null, ''],
        AdditionalFile9: [null, ''],
        AdditionalFile10: [null, ''],
      });

    this.photographyForm = this.formBuilder.group(
      {
        LateralExtraoral: [null, ''],
        FrontalExtraoral: [null, ''],
        SmileExtraoral: [null, ''],
        UpperOcclusal: [null, Validators.required],
        LowerOcclusal: [null, Validators.required],
        LeftLateralIntraoral: [null, Validators.required],
        FrontalIntraoral: [null, Validators.required],
        RightLateralIntraoral: [null, Validators.required],
      });

    this.compositeForm = this.formBuilder.group(
      {
        Composite: [null, Validators.required]
      });

    this.radiographyForm = this.formBuilder.group(
      {
        LateralRadiography: [null, ''],
        PanoramicRadiography: [null, ''],
        AditionalRadiography: [null, ''],
      });

    this.stlForm = this.formBuilder.group(
      {
        LowerSTL: [null, Validators.required],
        UpperSTL: [null, Validators.required],
        BiteSTL: [null, Validators.required],
      });
  }
  
  // ********************************************************************************
  // #region Methods StartupInfo
  // ********************************************************************************
  private getStartupInfo()
  {
    this.systemServicesDataService.getStartupInfo()
      .subscribe((startupInfo) =>
      {
        this.onApplicationStartup(startupInfo);
      }, error =>
      {
        if (error.status == 401)
        {
          this.forceLogout();
        }
      });
  }

  public forceLogout(): void
  {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');

    // Remove Token
    AppClientContext.Instance.headerValues.delete(ECOMMERCE_USER_TOKEN);

    // Clear current user
    AppClientContext.Instance.user = null;
  }

  private onApplicationStartup(startupInfo: any)
  {
    AppClientContext.Instance.initialize(startupInfo);

    // Save a reference to the angular injector to the client context
    AppClientContext.Instance.setInjector(this.injector);

    this.getCustomerInfo();
  }

  private getCustomerInfo() : void
  {
    if (AppClientContext.Instance.user)
    {
      this.customerDataService.getByUserId(AppClientContext.Instance.user.id)
        .subscribe((response: any) =>
        {
          let currentCustomer = response.items.firstOrNull();
          if (currentCustomer)
          {
            AppClientContext.Instance.customerId = currentCustomer.id;
            this.currentCustomer = currentCustomer;

            this.getCase();
          }
        });
    }
  }

  private getCase(): void
  {
    this.getById(this.caseId);
  }

  getBackCase(){
    this.router.navigate([`/ecommerce/mis-casos/detail/${this.caseId}`]);
  }

  public override getById(id: number, clearAlert: boolean = true): void
  {
    this.dataService.getCaseFromEcommerce(id, this.getQueryDefForGetById())
      .subscribe((response: any) =>
      {
        this.clearAlert(clearAlert);
        this.getAllCaseAdditionalFiles();
        this.getAllCaseStagesToCreateAStage();
        this.getByIdCallback(response);
      },
      (fail) =>
      {
        this.router.navigate(['/ecommerce']);
        this.setDangerAlert(fail.error.errorDetail.message);
      });
  }

  private getAllCaseStagesToCreateAStage(): void
  {
    if (this.caseId)
    {
      this.caseStageDataService.get(this.onGetQueryDefForCaseStages())
        .subscribe((response: any) =>
        {
          this.currentStages = response?.rows != null ? response?.rows : [];

          this.caseStageDataService.getLastCaseStageCreated(this.onGetQueryDefForGetLastCaseStageCreated())
          .subscribe((res)=>{

            this.currentStages = this.currentStages.filter(x=> x.isDeleted == false || (x.id == res.id && x.statusId == StatusesID.StageCancelled))
            this.stageSelected = this.currentStages.find(e=> e.stageNumber == this.stageNumber);
            if(!this.stageSelected) {
              this.router.navigate(['/ecommerce']);
              this.setDangerAlert(`La etapa ${this.stageNumber} no existe para este caso. Intente de nuevo`);
            }else{
              this.filePrescription.fileInfo =  this.stageSelected.setup.prescription.blob ? { name: this.stageSelected.setup.prescription.blob.name, url: this.stageSelected.setup.prescription.blob.path } : null;
              this.getAllCaseFiles();
            }

          })

        });
    }
  }

  public onGetQueryDefForCaseStages()
  {
    let queryDef = new UrlQueryDef();
    queryDef.includeDeletedRows = true;
    queryDef.includes = "Setup.Prescription.Blob";
    queryDef.filter = 'CaseId eq ' + this.caseId;
    queryDef.orderby = 'StageNumber';

    return queryDef;
  }

  protected onGetQueryDefForGetById(queryDef: UrlQueryDef)
  {
    queryDef.params = {};
    queryDef.params['customerId'] = AppClientContext.Instance.customerId;
    super.onGetQueryDefForGetById(queryDef);
  }

  private getAllCaseFiles(): void
  {
    this.caseFileDataService.getById(this.stageSelected.setup.caseFileId, this.onGetQueryDefForGetCaseFilesById())
      .subscribe((response: any) =>
      {
        this.caseFileResponse = response;
        this.setImagesCaseFile();
      });
  }

  onGetQueryDefForGetCaseFilesById(): UrlQueryDef
  {
    let queryDef = new UrlQueryDef();
    queryDef.includes = "FrontalIntraoral,UpperOcclusal,LowerOcclusal,LeftLateralIntraoral,RightLateralIntraoral,FrontalExtraoral,LateralExtraoral,SmileExtraoral,Composite,PanoramicRadiography,LateralRadiography,AditionalRadiography,BiteSTL,UpperSTL,LowerSTL";
    return queryDef;
  }

  private setImagesCaseFile(): void
  {
    if (this.caseFileResponse)
    {
      // SET COMPOSITE FILES
      for (const file of this.fileCompositeArray)
        this.setFileInfo(file);

      // SET COMPOSITE PHOTOGRAPHY FILES
      for (const file of this.fileImageArray)
        this.setFileInfo(file);

      // // // SET RADIOGRAPHY FILES
      for (const file of this.fileRadiographyArray)
        this.setFileInfo(file);

      // // SET STL FILES
      for (const file of this.fileSTLArray)
        this.setFileInfo(file);
    }
  }

  private setFileInfo(file: any)
  {
    let responsePath = this.caseFileResponse[`${FileTypeNamePath.get(file.type)}`];
    let name = FileTypeLabel.get(FileType.LateralExtraoralId);

    file.fileInfo = responsePath ? { name: name, url: responsePath } : null;
  }

  private getAllCaseAdditionalFiles(): void
  {
    this.caseAdditionalDataService.getCaseAdditional(this.onGetQueryDefForCaseAdditional())
      .subscribe((response: any) =>
      {
        this.additionalFilesResponse = response;
        this.setCaseAdditionalFiles();
      });
  }

  public onGetQueryDefForCaseAdditional(): UrlQueryDef
  {
    let queryDef = new UrlQueryDef();
    queryDef.addParam("caseId", this.caseId);
    return queryDef;
  }

  private setCaseAdditionalFiles(): void
  {
    for (let i = 0; i < this.additionalFilesResponse.length; i++)
    {
      if (i == 0)
      {
        this.fileAdditionalArray[i].Id = 0;
        this.fileAdditionalArray[i].label = this.additionalFilesResponse[i].name.slice(this.additionalFilesResponse[i].name.indexOf("_") + 1, this.additionalFilesResponse[i].name.length);
        this.fileAdditionalArray[i].name = "AdditionalFile" + i.toString();
        this.fileAdditionalArray[i].fileInfo = { name: this.additionalFilesResponse[i].name, url: this.additionalFilesResponse[i].path, blobId: this.additionalFilesResponse[i].blobId };
      }
      else
      {
        this.fileAdditionalArray.push(
          {
            Id: i,
            type: FileType.AdditionalCaseFileId,
            label: this.additionalFilesResponse[i].name.slice(this.additionalFilesResponse[i].name.indexOf("_") + 1, this.additionalFilesResponse[i].name.length),
            name: "AdditionalFile" + i.toString(),
            fileInfo: { name: this.additionalFilesResponse[i].name, url: this.additionalFilesResponse[i].path, blobId: this.additionalFilesResponse[i].blobId }

          }
        );
      }
    }

    if (this.additionalFilesResponse.length != 0)
      this.addNewElementFileAdditionalArray();
  }

  private addNewElementFileAdditionalArray(): void
  {
    if (this.fileAdditionalArray.length + 1 != 11)
    {
      //Add a new object
      this.fileAdditionalArray.push(JSON.parse(JSON.stringify(FileAdditionalArray)));
      this.fileAdditionalArray[this.fileAdditionalArray.length - 1].Id = this.fileAdditionalArray.length - 1;
      //Change the name dynamically
      this.fileAdditionalArray[this.fileAdditionalArray.length - 1].name = "AdditionalFile" + (this.fileAdditionalArray.length - 1).toString();
      this.fileAdditionalArray[this.fileAdditionalArray.length - 1].Id = this.fileAdditionalArray.length - 1;
    }
  }

  /**AdditionalFiles actions */
  public additionalFileSelected(file: File, item: any): void
  {
    this.mediaDataService.saveImage(file)
      .subscribe((responseMediaService: any) =>
      {
        let body =
        {
          caseId: this.caseId,
          blobId: responseMediaService.id
        };
        this.caseAdditionalDataService.saveCaseAdditional(body).subscribe((response: any) =>
        {
          this.setAdditionalFile(item.Id, responseMediaService, false);
        });
      }, (fail: any) =>
      {
        this.setWarningAlert(fail.error.message);
      });
  }

  public deleteAdditionalFileAction(item: any)
  {
    this.setAdditionalFile(item.Id, null, true);
  }

  private setAdditionalFile(id: any, fileBlobData: any, isDelete:boolean ): void
  {
    if (!isDelete)
    {
      this.fileAdditionalArray.find(x => x.Id == id).fileInfo = fileBlobData ? { name: fileBlobData.name, url: fileBlobData.path, blobId: fileBlobData.id } : null;
      this.fileAdditionalArray.find(x => x.Id == id).label = fileBlobData.name.slice(fileBlobData.name.indexOf("_") + 1, fileBlobData.name.length);
      //Add object
      this.addNewElementFileAdditionalArray();
    }
    else
    {
      this.deleteAdditionalFile(this.fileAdditionalArray[id].fileInfo.blobId, this.caseId);
      this.fileAdditionalArray.find(x => x.Id == id).fileInfo = fileBlobData ? { name: fileBlobData.name, url: fileBlobData.path, blobId: fileBlobData.id } : null;
      //Sort and erase
      if (this.fileAdditionalArray.length != 1)
      {
        this.fileAdditionalArray.splice(id, 1);
      }
      if (this.fileAdditionalArray.length == 9)
      {
        if ((this.fileAdditionalArray.find(x => x.fileInfo == null)) === undefined)
        {
          this.addNewElementFileAdditionalArray();
        }
      }
      for (let i = 0; i < this.fileAdditionalArray.length; i++)
      {
        this.fileAdditionalArray[i].Id = i;
        this.fileAdditionalArray[i].name = "AdditionalFile" + i.toString();
      }
    }
  }

  private deleteAdditionalFile(fileBlobId: any, fileCaseId): void
  {
    let body =
    {
      blobId: fileBlobId,
      caseId: fileCaseId
    };
    this.caseAdditionalDataService.deleteAdditionalFiles(body)
      .subscribe((response: any) =>
      {
        this.setInfoAlert("Archivo eliminado");
      }, (fail: any) =>
      {
        this.setWarningAlert(fail.error.message);
      });
  }

  /**Case FileS*/
  public fileSelected(file: File, item: any, fileArrayype: string): void
  {
    this.mediaDataService.saveImage(file)
      .subscribe((response: any) =>
      {

        this.setFile(item.type, fileArrayype, response);
        this.insertFileTypeFromMediaId(response.id, item);
      },
      (fail: any) =>
      {
        this.setFile(item.type, fileArrayype, { name: null, url: null });
        this.setWarningAlert(fail.error.message);
      });
  }

  private setFile(fileType: FileType, fileArrayype: string, fileBlobData: any): void
  {
    switch(fileArrayype)
    {
      case 'imageComposite':
        this.fileImageArray.find(x => x.type == fileType).fileInfo = fileBlobData ? { name: fileBlobData.name, url: fileBlobData.path} : null;
        break;
      case 'composite':
        this.fileCompositeArray.find(x => x.type == fileType).fileInfo = fileBlobData ? { name: fileBlobData.name, url: fileBlobData.path} : null;
        break;
      case 'radiography':
        this.fileRadiographyArray.find(x => x.type == fileType).fileInfo = fileBlobData ? { name: fileBlobData.name, url: fileBlobData.path} : null;
        break;
      case 'stl':
        this.fileSTLArray.find(x => x.type == fileType).fileInfo = fileBlobData ? { name: fileBlobData.name, url: fileBlobData.path} : null;
        break;
    }
  }

  private insertFileTypeFromMediaId(mediaId:number, item: any): void
  {
    let fileDto: UpdateFileDto = {
      id: this.stageSelected.setup.caseFileId,
      fileBlobId: mediaId,
      fileType: item.type
    };

    this.caseFileDataService.updateFile(fileDto)
      .subscribe((response: any) =>
      {
      },
      (fail: any) =>
      {
        this.setWarningAlert(fail.error.message);
      });
  }

  public deleteFile(item: any, fileArrayype: string)
  {
    let fileDto: UpdateFileDto = {
      id: this.stageSelected.setup.caseFileId,
      fileBlobId: null,
      fileType: item.type
    };

    this.caseFileDataService.updateFile(fileDto)
      .subscribe((response: any) =>
      {
        if (fileArrayype == "additionalFileDelete")
        {
          this.setFile(item.Id, fileArrayype, null);
        }
        else
        {
          this.setFile(item.type, fileArrayype, null);
        }
      },
      (fail: any) =>
      {
        this.setWarningAlert(fail.error.message);
      });
  }

  /**Prescription File */
  prescriptionFileSelected(file:any){
    this.mediaDataService.saveImage(file)
    .subscribe((response: any) =>
    {
        this.filePrescription.fileInfo = {
          name : response.name,
          url : response.path
        }
        this.uploadPrescriptionBlobId(response.id)
    });
  }

  uploadPrescriptionBlobId(blobId:number){
    //actualizacion de no se que 
    this.prescriptionDataService.updatePrescriptionFileBySetupId(this.stageSelected.setup.id, blobId).subscribe(res=>{
    }, err=>{
      this.setDangerAlert("Error al subir archivo de prescripción");
    })
  }

  deletePrescriptionFile(){
    this.prescriptionDataService.deleteFilePrescriptionById(this.caseId, this.stageSelected.stageNumber).subscribe(res=>{
      this.filePrescription.fileInfo = null;
    }, err=>{
      this.setDangerAlert("Error al eliminar archivo de prescripción");
    })
  }

  public onGetQueryDefForGetLastCaseStageCreated()
  {
    let queryDef = new UrlQueryDef();
    queryDef.params = {};
    queryDef.params['caseId'] = this.caseId;

    return queryDef;
  }

}
